import { render, staticRenderFns } from "./TrabajosMtto.vue?vue&type=template&id=1348ddc7&scoped=true"
import script from "./TrabajosMtto.vue?vue&type=script&lang=js"
export * from "./TrabajosMtto.vue?vue&type=script&lang=js"
import style0 from "./TrabajosMtto.vue?vue&type=style&index=0&id=1348ddc7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348ddc7",
  null
  
)

export default component.exports